import { useLocation, useMiniNavigate, useRouteParams } from '@yimoka/mini-router';
import type { IConfig, IGetIcon } from '@yimoka/react';
import { ConfigProvider } from '@yimoka/react';
import type { INotifier } from '@yimoka/store';
import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';

import { components } from '@/components';
import { apiExecutor } from '@/http';

const titleMap: Record<string, string> = {
  success: '成功',
  error: '错误',
  info: '提示',
  warning: '警告',
  warn: '警告',
  confirm: '确认',
  loading: '加载',
};

/** 暂不引入 UI 组件库时的简易通知器，仅控制台输出 */
const stubNotifier: INotifier = (type, msg, options) => {
  if (type === 'close' || type === 'destroy') return;
  const title = titleMap[type] ?? type;
  const desc = msg ?? options?.description;
  if (import.meta.env.DEV) {
    console.log(`[${title}]`, desc ?? options);
  }
};

export const InitConfig = (props: PropsWithChildren) => {
  const { children } = props;

  const notifier = useMemo(() => stubNotifier, []);

  const config: IConfig = useMemo(() => ({
    notifier,
    apiExecutor,
    components,
    getIcon,
    useNavigate: useMiniNavigate,
    useLocation,
    useRouteParams,
  }), [notifier]);

  return <ConfigProvider value={config}>{children}</ConfigProvider>;
};

// TODO: 待实现
const getIcon: IGetIcon = async (_icon: string) => null;

